import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Config } from '../../interfaces/config';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private httpBackendClient: HttpClient;

  /**
   * Runtime configuration
   */
  public get config(): Config {
    return this.privateConfig;
  }

  /**
   * Runtime configuration
   */
  public set config(config: Config) {
    this.privateConfig = config;
  }

  /**
   * Has the config loaded
   */
  public get loaded(): boolean {
    return this.privateLoaded;
  }

  private privateConfig!: Config;
  private privateLoaded!: boolean;

  constructor(httpBackend: HttpBackend) {
    this.httpBackendClient = new HttpClient(httpBackend);
  }

  async load(): Promise<void> {
    const jsonFile = 'configuration.json';
    return await new Promise<void>((resolve, reject) => {
      this.httpBackendClient.get<Config>(jsonFile).subscribe({
        next: (result) => {
          this.config = result;
          this.privateLoaded = true;
          resolve();
        },
        error: (error) => {
          reject(new Error(`Could not load file '${jsonFile}' : ${JSON.stringify(error, undefined, 2)}`));
        }
      });
    });
  }
}